import { Row, Col, Card, CardBody, CardHeader } from "reactstrap"

import { AvField } from "availity-reactstrap-validation"
import { useEffect, useState } from "react"

import Application from "services/applications/Application.service"
import { Link } from "react-router-dom"
const appService = new Application(JSON.parse(localStorage.getItem("authUser")))

const AssignStaff = props => {
  const [staffList, setStaffList] = useState()
  const [appDetails, setappDetails] = useState()
  
  // console.log( "Department",props.department)

  useEffect(() => {
    appService.getDepartmentOfficers(props.department).then(response => {
      // console.log( "Department Officers", response.data)
      const list = response.data.map((item, index) => {
        return (
          <option value={item.id} key={index}>
            {item.first_name + " " + item.last_name}
          </option>
        )
      })
      setStaffList(list)
      setappDetails(props.appDetails)
    })
  }, [])

  // useEffect(() => {}, [props.success, props.error, props.loading])

  return (
    <Card>
      <CardHeader className="alert alert-primary">Staff Assignment</CardHeader>
      <CardBody>
        {props.error && props.error == true ? (
          <Row className="alert alert-danger">
            <Col md="12">Error assigning staff. Please try again!</Col>
          </Row>
        ) : null}

        {props.success && props.success == true ? (
          <Row className="alert alert-success">
            <Col md="8">Staff successfully assigned!</Col>
            <Col md="4">
              <Link to="/dashboard" style={{ float: "right" }}>
                Back
              </Link>
            </Col>
          </Row>
        ) : null}

        <Row className="">
          <Col>
            <AvField
              type="hidden"
              name="assigned_by"
              value={props.appDetails.assignedBy}
            />

            <AvField
              type="hidden"
              name="application_id"
              value={props.appDetails.applicationId}
            />

            <AvField
              type="select"
              label="Select Staff"
              name="staff_id"
              disabled={props.success}
              required
            >
              <option value={""}>--Select Staff--</option>
              {staffList}
            </AvField>

            <br></br>
            
            {props.loading && props.loading === true ? (
              <Link
                to="#"
                className="spinner-border text-info"
                style={{ float: "right" }}
              />
            ) : (
              <button
                type="submit"
                className="btn btn-primary"
                style={{ float: "right" }}
                disabled={props.success}
              >
                Assign
              </button>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default AssignStaff
